export default function(fetch) {
  return function() {
    return fetch(`${process.env.REACT_APP_API_URL}/products/frames`).then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/getFrames.js